// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-integration-select-type-btn {
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./Source/app/external-platform-integration/ad-integration/group-mapping/select-type-cell/select-type-cell.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,uBAAA;AACJ","sourcesContent":[".ad-integration-select-type-btn {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
